export class ParallaxScroll {
    private element: JQuery<HTMLElement>;
    private speed: number;
    private originalOffset: number;

    constructor(element: JQuery<HTMLElement>, speed: number = 0.3) {
        this.element = element;
        this.speed = speed;
        this.originalOffset = element.offset()!.top;
        this.element.css("transform", "translateY(0)");

        $(window).on("load scroll", () => this.updatePosition());
    }

    private updatePosition(): void {
        const scrollPosition = $(window).scrollTop();
        assert(scrollPosition!==undefined);
        const scrolledPastElement = scrollPosition - this.originalOffset;
        const windowHeight=$(window).height();
        assert(windowHeight!==undefined);

        if (scrolledPastElement > -windowHeight && scrolledPastElement < windowHeight) {
            this.element.css(
                "transform",
                `translateY(${scrolledPastElement * this.speed}px)`
            );
        }
    }
}
export {};